import React from 'react';

/**
 * Safety Help Content
 */
const SafetyHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Safety Monitoring
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          The Safety page tracks policy violations and safety events in your agent operations. Monitor compliance, review violations, and maintain governance standards.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Violation Types
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Content</span>: Inappropriate or harmful content generated</p>
          <p>&#8226; <span className="font-medium">Behavior</span>: Unexpected or unauthorized agent actions</p>
          <p>&#8226; <span className="font-medium">Security</span>: Potential security risks or data exposure</p>
          <p>&#8226; <span className="font-medium">Compliance</span>: Regulatory or policy rule violations</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Severity Levels
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium text-red-600 dark:text-red-400">High</span>: Critical violations requiring immediate action</p>
          <p>&#8226; <span className="font-medium text-yellow-600 dark:text-yellow-400">Medium</span>: Significant issues to address promptly</p>
          <p>&#8226; <span className="font-medium text-blue-600 dark:text-blue-400">Low</span>: Minor violations for review</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Summary Stats
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Total Violations</span>: Count in the time period</p>
          <p>&#8226; <span className="font-medium">By Severity</span>: High, medium, low breakdown</p>
          <p>&#8226; <span className="font-medium">Compliance Rate</span>: Percentage of compliant runs</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Filtering Violations
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Use filters to focus on specific violations:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; Filter by severity level</p>
          <p>&#8226; Filter by violation type</p>
          <p>&#8226; Select date range</p>
          <p>&#8226; Search by agent or run ID</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Reviewing Violations
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Click on any violation to see full details including the triggering context, violated rule, and linked trace for investigation.
        </p>
      </div>

    </>
  );
};

export default SafetyHelp;
